import { render, staticRenderFns } from "./ConfigurazioneMagazzinoMagazziniListComponent.vue?vue&type=template&id=9799964a"
import script from "./ConfigurazioneMagazzinoMagazziniListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneMagazzinoMagazziniListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports